import React, { useEffect, useState, useRef } from 'react';
import {
  Row,
  Col,
  Typography,
  Input,
  Select,
  Pagination,
  Button,
  Radio,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styles from './bulk-data-feeds.module.sass';
import { STATUS } from '../../../../redux/constants';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';
import BulkDataFeedsPanel from '../../../../shared-components/BulkDataFeedsPanel';
import moment from 'moment';
import CopyEndpoint from '../../../../shared-components/CopyEndpoint';

//THIS IS UNUSED, see DataMarketplaceFeeds
function BulkDataFeeds(props) {
  const {
    loadBulkDataFeeds,
    bulkDataFeeds,
    bulkDataFeedsStatus,
    bulkDataDownloadStatus,
    bulkDataDownloadLink,
    clearBulkDataFeeds,
  } = props;
  const { Title, Text, Paragraph } = Typography;
  const { Search } = Input;

  const firstLoad = useRef(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [temporarySearchValue, setTemporarySearchValue] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [typeValue, setTypeValue] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [exportFormat, setExportFormat] = useState('');
  const [uuid, setUuid] = useState();
  const [showAutomateExportModal, setShowAutomateExportModal] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [modalFeedName, setModalFeedName] = useState('');
  const [selectedFeed, setSelectedFeed] = useState();

  useEffect(() => {
    if (sortOrder) {
      loadBulkDataFeeds(`?sort=${sortOrder}`);
    } else {
      loadBulkDataFeeds();
    }
    document.title = `Bulk Data Feeds - Silent Push`;

    setTimeout(() => {
      //after the first load turn off the count animation for further re-renders
      firstLoad.current = true;
    }, 1000);
    return () => {
      clearBulkDataFeeds();
    };
  }, []);

  useEffect(() => {
    let typeSearch = '';
    let titleSearch = '';

    if (typeValue) {
      typeSearch = '&feed_type=' + typeValue;
    }
    if (searchValue) {
      titleSearch = '&feed_name=' + searchValue;
    }
    if (sortOrder) {
      loadBulkDataFeeds(
        `?page=${currentPage}&sort=${sortOrder}${typeSearch}${titleSearch}`,
      );
    } else {
      loadBulkDataFeeds(`?page=${currentPage}${typeSearch}${titleSearch}`);
    }
  }, [sortOrder, typeValue, searchValue, currentPage]);

  useEffect(() => {
    if (uuid !== undefined) {
      setSelectedFeed(
        bulkDataFeeds?.results?.filter((f) => f?.uuid === uuid)?.[0],
      );
    }
  }, [uuid]);

  useEffect(() => {
    if (!showDownloadModal || !showAutomateExportModal) {
      setExportFormat('');
    }
  }, [showDownloadModal, showAutomateExportModal]);

  useEffect(() => {
    if (bulkDataDownloadStatus === STATUS.LOADED) {
      if (bulkDataDownloadLink) {
        window.open(bulkDataDownloadLink, '_blank');
      }
    }
  }, [bulkDataDownloadStatus]);

  const handleClearFilters = () => {
    setSearchValue('');
    setTypeValue(null);
    setSortOrder(null);
    setCurrentPage(1);
  };

  const bulkDataFeedsPagination = () => {
    if (bulkDataFeeds?.count > 9) {
      return (
        <Pagination
          current={currentPage}
          total={bulkDataFeeds?.count}
          pageSize={9}
          loading={bulkDataFeedsStatus === STATUS.LOADING}
          onChange={(current, pageSize) => {
            setCurrentPage(current);
            window.scrollTo(0, 0);
          }}
        />
      );
    } else {
      return null;
    }
  };

  return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
    props.mySubscriptionPlan?.has_access_to_bulk_data_feeds ? (
      <div className={styles.bulkDataFeeds}>
        <Row gutter={24} type="flex" className={styles.filtersRow}>
          <Col xs={24} xl={16} className={styles.filters}>
            <div className={styles.search}>
              <Text>Search Feeds</Text>
              <Search
                data-cy="bulkDataFeedsSearchField"
                value={temporarySearchValue}
                allowClear
                onPressEnter={(e) => {
                  setSearchValue(e.target.value);
                  setCurrentPage(1);
                }}
                placeholder="Search Feeds"
                onChange={(e) => {
                  setTemporarySearchValue(e.target.value);
                }}
                onSearch={(e) => {
                  setSearchValue(e);
                }}
              />
            </div>

            <div className={styles.input}>
              <Text>Filter Feeds by</Text>
              <Select
                data-cy="bulkDataFeedsFilterField"
                value={typeValue}
                placeholder="Select Feed Type"
                onChange={(e) => {
                  setTypeValue(e);
                  setCurrentPage(1);
                }}
                options={[
                  {
                    value: 'ipv4',
                    label: 'IPv4',
                  },
                  {
                    value: 'ipv6',
                    label: 'IPv6',
                  },
                  {
                    value: 'domain',
                    label: 'Domain',
                  },
                  {
                    value: 'url',
                    label: 'URL',
                  },
                ]}
              />
            </div>

            <div className={styles.input}>
              <Text>Sort Feeds by</Text>
              <Select
                data-cy="bulkDataFeedsSortField"
                value={sortOrder}
                placeholder="Select Sorting"
                onChange={(e) => {
                  setSortOrder(e);
                  setCurrentPage(1);
                }}
                options={[
                  {
                    value: '-last_updated',
                    label: 'Newer',
                  },
                  {
                    value: 'last_updated',
                    label: 'Older',
                  },
                ]}
              />
            </div>

            <Button
              type="link"
              onClick={() => handleClearFilters()}
              data-cy="bulkDataFeedsClearFiltersButton"
            >
              Clear Filters
            </Button>
          </Col>

          <Col xs={24} xl={8} className={styles.paginationTop}>
            {bulkDataFeedsPagination()}
          </Col>
        </Row>

        <Row gutter={24}>
          {bulkDataFeedsStatus === STATUS.LOADED &&
            bulkDataFeeds?.results?.map((feed) => {
              return (
                <Col sm={24} lg={12} xl={8}>
                  <BulkDataFeedsPanel
                    setUuid={setUuid}
                    setModalFeedName={setModalFeedName}
                    setShowDownloadModal={setShowDownloadModal}
                    setShowAutomateExportModal={setShowAutomateExportModal}
                    key={feed?.uuid}
                    serial={feed?.uuid}
                    observableCount={
                      feed?.number_of_observables
                        ? feed.number_of_observables
                        : 0
                    }
                    loading={false}
                    restricted={!feed?.has_access}
                    feedName={feed?.feed_name ? feed.feed_name : '-'}
                    obsType={feed?.feed_type ? feed.feed_type : '-'}
                    updated={
                      feed?.last_updated
                        ? moment(feed?.last_updated)
                            .utc()
                            .format('YYYY-MM-DD hh:mm A') + ' (UTC)'
                        : '-'
                    }
                    feedDescription={feed?.description}
                    firstLoad={firstLoad.current}
                    fileTypes={[
                      feed?.has_csv,
                      feed?.has_json,
                      feed?.has_txt,
                      feed?.has_rpz,
                      feed?.has_stix,
                    ]}
                  />
                </Col>
              );
            })}

          {bulkDataFeedsStatus === STATUS.LOADED && bulkDataFeeds?.count === 0 && (
            <div className={styles.noResult}>
              <div className={styles.content}>
                <SearchOutlined />
                <Title level={3}>No Results</Title>
                <Text>There are no bulk data feeds matching your filters.</Text>
              </div>
            </div>
          )}

          <CopyEndpoint
            centered
            endpoint={`${process.env.REACT_APP_API_URL}/api/v2/export/bulk-feeds/${selectedFeed?.file_name}.${exportFormat}`}
            title="Automate Export of Bulk Data Feed"
            description={
              <>
                <div className={styles.modalFeedName}>
                  <Text>Feed name:</Text>
                  <Paragraph
                    strong
                    data-cy="bulkDataFeedsDownloadModalFeedName"
                  >
                    {modalFeedName}
                  </Paragraph>
                </div>

                <Paragraph className="m-0" strong>
                  How to automate download:
                </Paragraph>
                <ul className={styles.modalDescriptionList}>
                  <li>Select the file type required</li>
                  <li>
                    Click the Copy API Endpoint button. This endpoint will
                    retrieve a time-limited URL (3h) that you can call to
                    download the file. Click on the cURL, Python or pHp tabs to
                    copy code samples and call it from your favorite security
                    tool. See our{' '}
                    <a href="http://docs.silentpush.com">API documentation</a>{' '}
                    for further details.
                  </li>
                </ul>

                <Text>Please select file type required:</Text>
                <br />
                <Radio.Group
                  onChange={(e) => setExportFormat(e.target.value)}
                  value={exportFormat}
                  data-cy="bulkDataFeedsDownloadModalTypeGroup"
                >
                  <Radio.Button value="csv" disabled={!selectedFeed?.has_csv}>
                    CSV
                  </Radio.Button>
                  <Radio.Button value="json" disabled={!selectedFeed?.has_json}>
                    JSON
                  </Radio.Button>
                  <Radio.Button value="txt" disabled={!selectedFeed?.has_txt}>
                    TXT
                  </Radio.Button>
                  <Radio.Button value="rpz" disabled={!selectedFeed?.has_rpz}>
                    RPZ
                  </Radio.Button>
                  <Radio.Button value="stix" disabled={!selectedFeed?.has_stix}>
                    STIX
                  </Radio.Button>
                </Radio.Group>
              </>
            }
            exportFormat={exportFormat}
            visible={showAutomateExportModal}
            handleShowAutomateExportModal={setShowAutomateExportModal}
          />

          <CopyEndpoint
            centered
            endpoint={`${process.env.REACT_APP_API_URL}/api/v2/export/bulk-feeds/${selectedFeed?.file_name}.${exportFormat}`}
            title="Download of Bulk Data Feed"
            description={
              <>
                <div className={styles.modalFeedName}>
                  <Text>Feed name:</Text>
                  <Paragraph strong>{modalFeedName}</Paragraph>
                </div>

                <Paragraph className="m-0" strong>
                  How to download the file:
                </Paragraph>
                <ul className={styles.modalDescriptionList}>
                  <li>Select the file type required</li>
                  <li>
                    Click the Download File button, below the file types, and
                    file will immediately download in the browser
                  </li>
                </ul>

                <Text>Please select file type required:</Text>
                <br />
                <Radio.Group
                  onChange={(e) => setExportFormat(e.target.value)}
                  value={exportFormat}
                  data-cy="bulkDataFeedsExportModalTypeGroup"
                >
                  <Radio.Button value="csv" disabled={!selectedFeed?.has_csv}>
                    CSV
                  </Radio.Button>
                  <Radio.Button value="json" disabled={!selectedFeed?.has_json}>
                    JSON
                  </Radio.Button>
                  <Radio.Button value="txt" disabled={!selectedFeed?.has_txt}>
                    TXT
                  </Radio.Button>
                  <Radio.Button value="rpz" disabled={!selectedFeed?.has_rpz}>
                    RPZ
                  </Radio.Button>
                  <Radio.Button value="stix" disabled={!selectedFeed?.has_stix}>
                    STIX
                  </Radio.Button>
                </Radio.Group>

                <br />

                <Button
                  className="mt-1"
                  disabled={exportFormat?.length > 0 ? false : true}
                  type="primary"
                  onClick={() =>
                    props.downloadBulkDataFeed(
                      `${selectedFeed?.file_name}.${exportFormat}`,
                    )
                  }
                  loading={bulkDataDownloadStatus === STATUS.LOADING}
                >
                  Download file
                </Button>
              </>
            }
            exportFormat={exportFormat}
            visible={showDownloadModal}
            handleShowDownloadModal={setShowDownloadModal}
          />

          {bulkDataFeedsStatus === STATUS.LOADING && (
            <>
              <Col sm={24} lg={12} xl={8}>
                <BulkDataFeedsPanel
                  key={'1'}
                  serial={'1'}
                  loading={true}
                  firstLoad={firstLoad.current}
                />
              </Col>
              <Col sm={24} lg={12} xl={8}>
                <BulkDataFeedsPanel
                  key={'2'}
                  serial={'2'}
                  loading={true}
                  firstLoad={firstLoad.current}
                />
              </Col>
              <Col sm={24} lg={12} xl={8}>
                <BulkDataFeedsPanel
                  key={'3'}
                  serial={'3'}
                  loading={true}
                  firstLoad={firstLoad.current}
                />
              </Col>
            </>
          )}
        </Row>

        <Row>
          <Col xs={24} className={styles.paginationBottom}>
            {bulkDataFeedsPagination()}
          </Col>
        </Row>
      </div>
    ) : (
      <PermissionDeniedPage />
    )
  ) : (
    <LoadingSilentPush size={80} positionCenter />
  );
}

export default BulkDataFeeds;
